import { useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { addTopic } from "../../actions/topicActions";
import interested from "../../utils/interested.json";
import InterestedCard from "../InterestedCard";
import "./SettingTopics.css";

const SettingTopics = () => {
  const dispatch = useDispatch();
  const { topicVideos } = useSelector((state) => state.topic);
  const [selectedTopic, setSelectedTopic] = useState(
    topicVideos.length ? [] : interested
  );
  const handleSaveSelectedTopic = () => {
    dispatch(addTopic(selectedTopic));
  };

  const handleAddAllTopic = () => {
    setSelectedTopic(interested);
  };
  const handleRemoveAllTopic = () => {
    setSelectedTopic(topicVideos);
  };

  return (
    <div className="settingTopics">
      <div className="settingTopics__container">
        {interested.map((i, index) => (
          <InterestedCard
            selectAll={selectedTopic.length === interested.length}
            setSelectedTopic={setSelectedTopic}
            selectedTopic={selectedTopic}
            img={i.img}
            category={i.category}
            key={index}
            id={i.id}
          />
        ))}
      </div>
      <br />
      <br />
      <br />
      <br />
      <div className="settingTopics__btnContainer flex-row">
        <small>
          If you don't know your passion yet,
          <br /> then{" "}
          <span
            // className={topicVideos.length && "settingTopics__removeAll"}
            onClick={handleAddAllTopic}
          >
            select all.
          </span>
        </small>
        <div className="flex-row">
          <button className="btn" onClick={handleRemoveAllTopic}>
            Cancel
          </button>
          <button
            //   className={
            //     topicVideos.length !== 0
            //       ? "btn primary settingTopics"
            //       : "btn secondary settingTopics"
            //   }
            className="btn primary"
            onClick={handleSaveSelectedTopic}
            //   onClick={topicVideos.length === 0 ? interestedAddAll : test2}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingTopics;
